import { SpaceAdminServiceImpl } from './services/space-admin-service';
import { SpaceAdminService } from './services/space-admin-service.interface';
import { QuerySpaceAdminRepository } from './services/space-admin-repository.interface';
import { QuerySpaceAdminRepositoryImpl } from './repository/space-admin-repository';
import { ApiQuerySpaceAdmins } from '@/infrastructure/api-functions/api-query-space-admins.interface';
import { SpaceApiServiceImpl } from '@/infrastructure/api-functions/space-api-service';
import { ApUpdateSpaceAdmins } from '@/infrastructure/api-functions/api-update-space-admins.interface';
import { SpaceAdminModel, SpaceAdminModelImpl } from './model/space-admin';
export function spaceAdminModule(bind) {
    bind(SpaceAdminModel).to(SpaceAdminModelImpl);
    bind(SpaceAdminService).to(SpaceAdminServiceImpl);
    bind(QuerySpaceAdminRepository).to(QuerySpaceAdminRepositoryImpl);
    bind(ApiQuerySpaceAdmins).to(SpaceApiServiceImpl);
    bind(ApUpdateSpaceAdmins).to(SpaceApiServiceImpl);
}
